module.exports = __webpack_public_path__ + "static/media/profilePhoto.9acfe78b.png";